import CreateAttributesDialog from './createAttributesDialog.container';

export default CreateAttributesDialog